import React from 'react'
import Modal from '../shared/modal'
import { t } from '../../i18n'

const KitchenConfigurationWarningModal = ({ warnings, onClose, redirectToLocations = false }) => {

  const closeModal = () => {
    onClose()
    if(redirectToLocations) {
      window.location.href = '/admin/locations'
    }
  }

  return (
    <Modal
      headerText={t('locations.kitchen_configuration.validations.warning')}
      onClose={onClose}
    >
      <div className='mb-5'>
        {warnings.map((warning, index) => (
          <div key={index}>{warning}</div>
        ))}
      </div>
      <div>
        <button
          className='btn btn-primary'
          onClick={closeModal}
        >
          Close
        </button>
      </div>
    </Modal>
  )
}

export default KitchenConfigurationWarningModal
